import { Injectable, signal } from '@angular/core';
import { PeriodOption } from '../models/dashboard.types';

@Injectable({
  providedIn: 'root',
})
export class UiStateService {
  selectedPeriod = signal<PeriodOption>('Month');
  startDate = signal<Date | null>(null);
  endDate = signal<Date | null>(null);

  sessionOrgId = signal<number | null>(null);
  sessionUserId = signal<number | null>(null);
  sessionSearch = signal<string>('');

  constructor() {
    const today = new Date();
    this.startDate.set(new Date(today.getFullYear(), today.getMonth(), 1));
    this.endDate.set(today);
  }

  setPeriod(period: PeriodOption) {
    this.selectedPeriod.set(period);
  }

  setRange(startDate: Date, endDate: Date) {
    this.startDate.set(startDate);
    this.endDate.set(endDate);
  }

  getRange(): { startDate: Date; endDate: Date } {
    const start = this.startDate() ?? new Date();
    const end = this.endDate() ?? new Date();
    const startDate = new Date(start);
    const endDate = new Date(end);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);
    return { startDate, endDate };
  }

  clearSessionFilters() {
    this.sessionOrgId.set(null);
    this.sessionUserId.set(null);
    this.sessionSearch.set('');
  }

  setSessionUserFilter(userId: number) {
    this.sessionOrgId.set(null);
    this.sessionSearch.set('');
    this.sessionUserId.set(userId);
  }
}
